import React, { forwardRef } from 'react';
import classNames from 'classnames';
import withAnalytics from '../../hocs/withAnalytics';
import styles from './Button.module.css';

const Button = forwardRef(({ children, className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={classNames(styles.component_slots, className)}
    {...props}
  >
    {children}
  </button>
));

export default Button;

export const ButtonWithAnalytics = withAnalytics(Button);
